/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_SuccessInputs */



/**
* | output |
* | --- |
* | "Checked in!" |
*
* @param {Checkin_Qr_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_success = /** @type {((inputs?: Checkin_Qr_SuccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_SuccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pointé !")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Check-in hecho!")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Check-in realizado!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Check-in effettuato!")
	return /** @type {LocalizedString} */ ("Checked in!")
});